import React, { createContext, useMemo } from 'react';

import type { PaymentCardRef } from '../types';

export type CheckoutContextType = {
  paymentMethodRef?: React.RefObject<PaymentCardRef>;
};

export const CheckoutContext = createContext<CheckoutContextType | null>(null);

type CheckoutContextProviderProps = {
  children: React.ReactNode;
  paymentMethodRef?: React.RefObject<PaymentCardRef>;
};

export const CheckoutContextProvider: React.FC<CheckoutContextProviderProps> = ({ paymentMethodRef, children }) => {
  const contextValue = useMemo(() => ({ paymentMethodRef }), [paymentMethodRef]);

  return <CheckoutContext.Provider value={contextValue}>{children}</CheckoutContext.Provider>;
};
